// What a campaign's texts and emails look like to a client: a sample first
// name, the salon's name, and the salon's real links in place of the merge
// tags (the booking link is personalised per client when it sends, so the
// preview shows the salon's own booking page).
import siteSetting from '../../../../../config/env'
import { getShareContext } from '../../../../shared/shareLinks'

const WEB = (siteSetting && siteSetting.api && siteSetting.api.weburl) || '/'
export const SAMPLE_NAME = 'Sophie'

// The salon's public links, for previews
export const previewLinks = (hairdresser) => {
  const { salonSlug } = getShareContext(hairdresser)
  if (!salonSlug) return {}
  const base = `${WEB}book/${salonSlug}`
  return { BookingLink: base, GiftCardLink: `${base}/gift-cards`, ShopLink: `${base}/shop` }
}

// A link as a phone shows it in a text: no https://, no trailing slash
export const shortLink = (url) => String(url || '').replace(/^https?:\/\//, '').replace(/\/$/, '')

// A text or subject line as the client sees it
export const previewText = (text, { salonName = '', links = {}, firstName = SAMPLE_NAME, short = true } = {}) => {
  const link = (key) => (links[key] ? (short ? shortLink(links[key]) : links[key]) : null)
  const booking = link('BookingLink') || 'your booking page'
  return String(text || '')
    .replace(/\{\{\s*FirstName\s*\}\}/g, firstName)
    .replace(/\{\{\s*SalonName\s*\}\}/g, salonName || 'Your salon')
    .replace(/\{\{\s*BookingLink\s*\}\}/g, booking)
    .replace(/\{\{\s*GiftCardLink\s*\}\}/g, link('GiftCardLink') || booking)
    .replace(/\{\{\s*ShopLink\s*\}\}/g, link('ShopLink') || booking)
}
